export default {
  dataIterator: {
    rowsPerPageText: 'Item setiap halaman:',
    rowsPerPageAll: 'Semua',
    pageText: '{0}-{1} dari {2}',
    noResultsText: 'Tidak ditemukan catatan yang cocok',
    nextPage: 'Halaman selanjutnya',
    prevPage: 'Halaman sebelumnya'
  },
  dataTable: {
    rowsPerPageText: 'Baris setiap halaman:'
  },
  noDataText: 'Tidak ada data tersedia',
  carousel: {
    prev: 'Visual sebelumnya',
    next: 'Visual selanjutnya'
  }
}
